import { TrackingContext } from '@/tracking/Tracking.context';
import { useContext } from 'react';
import { Button } from '@/components/ui/button';

export const TrackingView = () => {
	const { sendEvent } = useContext(TrackingContext);

	return (
		<div>
			Hello World
			<br />
			<Button
				variant={'outline'}
				onClick={(e) => {
					e.preventDefault();
					sendEvent({
						type: 'BTN_CLICK_ISSUE',
						data: {
							issue: {
								id: 1,
							},
						},
					});
				}}
				className={`cursor-pointer h-8 mt-4`}
			>
				More
			</Button>
		</div>
	);
};
